__turbopack_context__.v({
  "date-picker": "NB5-MG_date-picker",
  "date-picker--disabled": "NB5-MG_date-picker--disabled",
  "date-picker--has-error": "NB5-MG_date-picker--has-error",
  "date-picker__calendar-button": "NB5-MG_date-picker__calendar-button",
  "date-picker__calendar-button-wrapper": "NB5-MG_date-picker__calendar-button-wrapper",
  "date-picker__clear-button": "NB5-MG_date-picker__clear-button",
  "date-picker__date-format-hint": "NB5-MG_date-picker__date-format-hint",
  "date-picker__error-icon": "NB5-MG_date-picker__error-icon",
  "date-picker__header-button-previous": "NB5-MG_date-picker__header-button-previous",
  "date-picker__input-wrapper": "NB5-MG_date-picker__input-wrapper",
});
